import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import EventDetail from "../pages/event/page";
import BusinessPage from "../pages/business/page";
import RecruitPage from "../pages/recruit/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/event/:slug",
    element: <EventDetail />,
  },
  {
    path: "/business",
    element: <BusinessPage />,
  },
  {
    path: "/recruit",
    element: <RecruitPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
